import { useCallback } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { SignatureForm } from '@/components/settings/SignatureForm';
import { useSignatureStore } from '@/stores/signatureStore';
import { useUIStore } from '@/stores/uiStore';

export function SignatureModalHost() {
  const signatureEditorOpen = useUIStore((state) => state.signatureEditorOpen);
  const setSignatureEditorOpen = useUIStore((state) => state.setSignatureEditorOpen);
  const signatureEditorTarget = useUIStore((state) => state.signatureEditorTarget);
  const setSignatureEditorTarget = useUIStore((state) => state.setSignatureEditorTarget);
  const setGlobalError = useUIStore((state) => state.setGlobalError);
  const createSignature = useSignatureStore((state) => state.createSignature);
  const updateSignature = useSignatureStore((state) => state.updateSignature);
  const saving = useSignatureStore((state) => state.saving);

  const handleSave = useCallback(
    async (values: { name: string; html: string }) => {
      try {
        if (signatureEditorTarget) {
          await updateSignature(signatureEditorTarget.id, values);
        } else {
          await createSignature(values);
        }
        setSignatureEditorOpen(false);
        setSignatureEditorTarget(null);
      } catch (error) {
        console.error('Failed to save signature', error);
        setGlobalError('Failed to save signature');
      }
    },
    [createSignature, setGlobalError, setSignatureEditorOpen, setSignatureEditorTarget, signatureEditorTarget, updateSignature]
  );

  const handleClose = useCallback(() => {
    setSignatureEditorOpen(false);
    setSignatureEditorTarget(null);
  }, [setSignatureEditorOpen, setSignatureEditorTarget]);

  return (
    <Dialog open={signatureEditorOpen} onOpenChange={handleClose}>
      <DialogContent className="w-full max-w-3xl p-0 overflow-hidden bg-background h-[85vh] max-h-[800px]">
        <SignatureForm
          signature={signatureEditorTarget}
          onSave={handleSave}
          onCancel={handleClose}
          saving={saving}
        />
      </DialogContent>
    </Dialog>
  );
}
